import { ADDRESS_GEO_ORDER } from "./addressGeoHierarchy";
import { AddressGeoSelections } from "./types";

export const buildFullAddress = (selections: AddressGeoSelections): string =>
  ADDRESS_GEO_ORDER.map((token) => selections[token]?.name)
    .filter(Boolean)
    .join(", ");
